export default __webpack_public_path__ + "static/media/btn_img.0e32b3e4.svg";